<div id="main">
    <div class="content">
        <div class="d-flex justify-content-center" style="margin-left: 1%; cursor: pointer;"
            (click)="openAggiungiUtenteModal()">
            <h3>Users Management</h3>

        </div>
        <div class="d-flex justify-content-center" style="cursor: pointer; margin-left: 1%;" *ngIf="isUserAdmin()"
            (click)="openAggiungiUtenteModal()">
            <div class="d-flex align-items-center" style="white-space: nowrap ;">
                <i class="fa-solid fa-circle-plus fa-2x"></i>
                <span class="small span-icon" style="margin-left: 7%;">Add User</span>
            </div>

        </div>
        <div class="d-flex justify-content-center mt-1">
            <ng2-smart-table [settings]="settings" [source]="listUtenti">
            </ng2-smart-table>


        </div>

    </div>
</div>

<ng-template #confirmElimina let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <div class="modal-body">
        <p>Clicking Delete will proceed with the elimination of the user {{userToDelete}}.</p>
        <span *ngIf="deleteDisabledForMyUser()" style="color: red;"> It is not possible to delete your own
            account!</span>
    </div>
    <div class="modal-footer footer-modal-background-color">
        <button class="btn btn-primary btn-lg active" [disabled]="deleteDisabledForMyUser()"
            (click)="modal.close(true)">Delete</button>
        <button class="btn btn-primary btn-lg active button-reset" (click)="modal.close(false)">Cancel</button>
    </div>
</ng-template>

<ng-template #updateUtente let-modal>
  <div class="modal-header header-background-color">
    <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
    <div (click)="modal.close(false)">
      <i class="fa-solid fa-xmark close-modal-color"></i>
    </div>
  </div>
  <form [formGroup]="updateUtenteForm">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-4">
          <label>Username</label><br>
          <span>{{userNameUpdateModal}}</span>
        </div>
        <div class="col-md-4">
          <label>User Create</label><br>
          <span>{{userCreateUpdateModal}}</span>
        </div>
        <div class="col-md-4">
          <label>User Last Update</label><br>
          <span>{{userLastUpdateUpdateModal}}</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4">
          <label>Insert Date</label><br>
          <span>{{userDataInsUpdateModal}}</span>
        </div>
        <div class="col-md-4">
          <label>Last Update Date</label><br>
          <span>{{userLastUpdateDateUpdateModal}}</span>
        </div>
        <div class="col-md-4">

        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4 ">
          <label for="nome">Name *</label>
          <input type="text" formControlName="nome"
                 [ngClass]="{'input-error': updateUtenteForm && updateUtenteForm.get('nome')?.errors && updateUtenteForm.get('nome')?.hasError('required')}"
                 class="form-control" id="nome" name="nome" placeholder="Name">
        </div>
        <div class="col-md-4 ">
          <label for="cognome">Surname *</label>
          <input type="text" formControlName="cognome"
                 [ngClass]="{'input-error': updateUtenteForm && updateUtenteForm.get('cognome')?.errors && updateUtenteForm.get('cognome')?.hasError('required')}"
                 class="form-control" id="cognome" name="cognome" placeholder="Surname">
        </div>
        <div class="col-md-4 ">
          <label for="phoneNumber">Phone Number *</label>
          <input type="text" formControlName="phoneNumber"
                 [ngClass]="{'input-error': updateUtenteForm && updateUtenteForm.get('phoneNumber')?.errors && updateUtenteForm.get('phoneNumber')?.hasError('required')}"
                 class="form-control" id="phoneNumber" name="phoneNumber" placeholder="Phone Number">
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-4 ">
          <label for="mail">E-mail *</label>
          <input type="email" formControlName="mail"
                 [ngClass]="{'input-error': updateUtenteForm && updateUtenteForm.get('mail')?.errors && updateUtenteForm.get('mail')?.hasError('required')}"
                 class="form-control" id="mail" name="mail" placeholder="E-mail">
        </div>

        <div class="col-md-4">
          <label for="group">Group *</label>
          <select [disabled]="groupUpdateModalDisable" formControlName="group"
                  [ngClass]="{'input-error': updateUtenteForm && updateUtenteForm.get('group')?.errors && updateUtenteForm.get('group')?.hasError('required')}"
                  class="form-select" id="group" name="group" (change)="onRoleSelectionChangeUpdate($event)">
            <option *ngFor="let item of tendinaGruppi" [ngValue]="item.valore">
              {{ item.etichetta }}
            </option>
          </select>
        </div>

        <div class="col-md-4" *ngIf="updateUtenteForm.get('group')?.value !== 'ADMIN_FREEMOVE_FE'">
          <label for="operator">Operator *</label>
          <select formControlName="operator"
                  class="form-select" id="operator" name="operator"
                  (change)="onOperatorChangeUpdate($event)">
            <option *ngFor="let operator of listOperatorView" [value]="operator.id">
              {{ operator.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-2" *ngIf="updateFormDisabled()">
        <span class="span-error">Fill in all mandatory fields marked with *</span>
      </div>

      <div class="row mt-2" *ngIf="isFasAdmin() && isNewRoleUpdate() && updateUtenteForm.get('group')?.value !== 'ADMIN_FREEMOVE_FE'">
        <div class="col-md-12 mt-3" *ngIf="updateUtenteForm.get('operator')?.value">

          <ng-container *ngIf="isSingleCustomerSelection(updateUtenteForm); else multiCustomerUpdate">

            <label for="customer">Customer *</label>

            <select
              formControlName="customer"
              (change)="onCustomerChangeUpdate()"
              [ngClass]="{'input-error': updateUtenteForm && updateUtenteForm.get('customer')?.errors && updateUtenteForm.get('customer')?.hasError('required')}"
              class="form-select"
              id="customer"
              name="customer">

              <option *ngFor="let customer of listCustomerView" [value]="customer">
                {{ customer }}
              </option>

            </select>

          </ng-container>

          <ng-template #multiCustomerUpdate>

            <label class="d-flex justify-content-between align-items-center">
              <span>Customer *</span>

              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="selectAll(updateUtenteForm, 'customer', listCustomerView)">
                  Select All
                </button>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  (click)="clearAll(updateUtenteForm, 'customer')">
                  Clear
                </button>
              </div>
            </label>

            <div class="selection-box">
              <div class="selection-list">
                <div
                  *ngFor="let customer of listCustomerView"
                  class="selection-row"
                  [class.active]="isSelected(updateUtenteForm, 'customer', customer)"
                  (click)="toggleSelection(updateUtenteForm, 'customer', customer)">

                  <input
                    type="checkbox"
                    class="form-check-input"
                    [checked]="isSelected(updateUtenteForm, 'customer', customer)"
                    tabindex="-1">

                  <span>{{ customer }}</span>
                </div>
              </div>
            </div>

            <div class="selection-summary">
              Selected: {{ getSelectedCount(updateUtenteForm, 'customer') }}
            </div>

          </ng-template>

        </div>
      </div>

      <div class="row mt-2" *ngIf="isFasAdmin() && billingTableLO && billingTableLO.length > 0 && updateUtenteForm.get('group')?.value !== 'ADMIN_FREEMOVE_FE'">
        <div class="col-md-12">
          <label class="d-flex justify-content-between align-items-center">
                        <span>
                            Billing Account(s)
                            <span *ngIf="updateUtenteForm.get('group')?.value !== 'FLEET_MANAGER' && updateUtenteForm.get('group')?.value !== 'FLEET_MANAGER_ADMIN'">
                                Lead Operator
                            </span>
                        </span>

            <div class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="selectAll(updateUtenteForm, 'billingAccountLO', getBillingIds(billingTableLO))">
                Select All
              </button>

              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                (click)="clearAll(updateUtenteForm, 'billingAccountLO')">
                Clear
              </button>
            </div>
          </label>

          <div class="selection-box">
            <div class="selection-list">
              <div
                *ngFor="let account of billingTableLO"
                class="selection-row"
                [class.active]="isSelected(updateUtenteForm, 'billingAccountLO', account.billingAccountId)"
                (click)="toggleSelection(updateUtenteForm, 'billingAccountLO', account.billingAccountId)">

                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="isSelected(updateUtenteForm, 'billingAccountLO', account.billingAccountId)"
                  tabindex="-1">

                <span class="billing-account-info">
                  <span class="billing-account-id">{{ account.billingAccountId }}</span>

                  <small class="billing-account-customer" *ngIf="account.customerName">
                    {{ account.customerName }}
                  </small>

                  <small class="billing-account-local-customer" *ngIf="account.localCustomerName">
                    {{ account.localCustomerName }}
                  </small>
                </span>
              </div>
            </div>
          </div>

          <div class="selection-summary">
            Selected: {{ getSelectedCount(updateUtenteForm, 'billingAccountLO') }}
          </div>
        </div>
      </div>

      <div class="row mt-2" *ngIf="isFasAdmin() && billingTableData && billingTableData.length > 0 && updateUtenteForm.get('group')?.value !== 'ADMIN_FREEMOVE_FE'">
        <div class="col-md-12">
          <label class="d-flex justify-content-between align-items-center">
            <span>Billing Account(s) B Operator*</span>

            <div class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="selectAll(updateUtenteForm, 'billingAccount', getBillingIds(billingTableData))">
                Select All
              </button>

              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                (click)="clearAll(updateUtenteForm, 'billingAccount')">
                Clear
              </button>
            </div>
          </label>

          <div class="selection-box">
            <div class="selection-list">
              <div
                *ngFor="let account of billingTableData"
                class="selection-row"
                [class.active]="isSelected(updateUtenteForm, 'billingAccount', account.billingAccountId)"
                (click)="toggleSelection(updateUtenteForm, 'billingAccount', account.billingAccountId)">

                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="isSelected(updateUtenteForm, 'billingAccount', account.billingAccountId)"
                  tabindex="-1">

                <span class="billing-account-info">
                  <span class="billing-account-id">{{ account.billingAccountId }}</span>

                  <small class="billing-account-customer" *ngIf="account.customerName">
                    {{ account.customerName }}
                  </small>

                  <small class="billing-account-local-customer" *ngIf="account.localCustomerName">
                    {{ account.localCustomerName }}
                  </small>
                </span>
              </div>
            </div>
          </div>

          <div class="selection-summary">
            Selected: {{ getSelectedCount(updateUtenteForm, 'billingAccount') }}
          </div>
        </div>
      </div>

      <div class="row mt-2" *ngIf="updateFormDisabled()">
        <span class="span-error">Fill in all mandatory fields marked with *</span>
      </div>
    </div>

    <div class="modal-footer footer-modal-background-color">
      <button class="btn btn-primary btn-lg active" *ngIf="changePasswordEnabled()"
              (click)="openChangePasswordModal()">Change Password</button>
      <button class="btn btn-primary btn-lg active" [disabled]="updateFormDisabled()"
              (click)="modal.close(true)">Update</button>
      <button class="btn btn-primary btn-lg active button-reset" (click)="modal.close(false)">Cancel</button>
    </div>
  </form>
</ng-template>


<ng-template #confirmSave let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <div class="modal-body">
        <p class="text-modal-style">Clicking Confirm will proceed with saving the user</p>
    </div>
    <div class="modal-footer footer-modal-background-color">
        <button class="btn btn-primary btn-lg active" (click)="modal.close(true)">Confirm</button>
        <button class="btn btn-primary btn-lg active button-reset" (click)="modal.close(false)">Cancel</button>
    </div>
</ng-template>

<ng-template #aggiungiUtente let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <form [formGroup]="aggiungiUtenteForm">
        <div class="modal-body">
            <div class="row mt-2">
                <div class="col-md-4 ">
                    <label for="nome">Name *</label>
                    <input type="text" formControlName="nome"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('nome')?.errors && aggiungiUtenteForm.get('nome')?.hasError('required')}"
                        class="form-control" id="nome" name="nome" placeholder="Name" autocomplete="off">


                </div>
                <div class="col-md-4 ">
                    <label for="cognome">Surname *</label>
                    <input type="text" formControlName="cognome"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('cognome')?.errors && aggiungiUtenteForm.get('cognome')?.hasError('required')}"
                        class="form-control" id="cognome" name="cognome" placeholder="Surname" autocomplete="off">


                </div>

                <div class="col-md-4">
                    <label for="username">Username *

                    </label>
                    <input type="text" formControlName="username"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('username')?.errors && aggiungiUtenteForm.get('username')?.hasError('required')}"
                        class="form-control" id="username" name="username" placeholder="Username" autocomplete="off">

                </div>

            </div>
            <div class="row mt-2">

                <div class="col-md-4 ">
                    <label for="mail">E-mail *</label>
                    <input type="email" formControlName="mail"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('mail')?.errors && aggiungiUtenteForm.get('mail')?.hasError('required')}"
                        class="form-control" id="mail" name="mail" placeholder="E-mail" autocomplete="off">
                </div>

                <div class="col-md-4 ">
                    <label for="phoneNumber">Phone Number *

                    </label>
                    <input type="text" formControlName="phoneNumber"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('phoneNumber')?.errors && aggiungiUtenteForm.get('phoneNumber')?.hasError('required')}"
                        class="form-control" id="phoneNumber" name="phoneNumber" placeholder="PhoneNumber"
                        autocomplete="off">

                </div>

                <div class="col-md-4">
                    <label for="password">Password *

                    </label>
                    <input type="password" formControlName="password"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('password')?.errors && aggiungiUtenteForm.get('password')?.hasError('required')}"
                        class="form-control" id="password" name="password" placeholder="Password" autocomplete="off">

                </div>
            </div>
            <div class="row mt-2">

                <div class="col-md-4">
                    <label for="confirmPassword">Confirm Password *</label>
                    <input type="password" formControlName="confirmPassword"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('confirmPassword')?.errors && aggiungiUtenteForm.get('confirmPassword')?.hasError('required')}"
                        class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Password"
                        autocomplete="off">
                </div>

                <div class="col-md-4">
                    <label for="group">Role *</label>
                    <select formControlName="group"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('group')?.errors && aggiungiUtenteForm.get('group')?.hasError('required')}"
                        class="form-select" id="group" name="group"  (change)="onRoleSelectionChange($event)">
                        <option *ngFor="let item of tendinaGruppi" [ngValue]="item.valore">
                            {{ item.etichetta }}
                        </option>
                    </select>
                </div>

                <ng-container *ngIf="isFasAdmin()  && isNewRole()">
                    <div class="col-md-4">
                        <label for="operator">Operator *</label>
                        <select formControlName="operator"
                            class="form-select" id="operator" name="operator"
                            (change)="onOperatorChange($event)">
                            <option *ngFor="let operator of listOperatorView" [value]="operator.id">
                                {{ operator.name }}
                            </option>
                        </select>
                    </div>
                  <div class="col-md-12 mt-3" *ngIf="aggiungiUtenteForm.get('operator')?.value">

                    <ng-container *ngIf="isSingleCustomerSelection(aggiungiUtenteForm); else multiCustomer">

                      <label for="customer">Customer *</label>

                      <select
                        formControlName="customer"
                        (change)="onCustomerChange($event)"
                        [ngClass]="{'input-error': aggiungiUtenteForm && aggiungiUtenteForm.get('customer')?.errors && aggiungiUtenteForm.get('customer')?.hasError('required')}"
                        class="form-select"
                        id="customer"
                        name="customer">

                        <option *ngFor="let customer of listCustomerView" [value]="customer">
                          {{ customer }}
                        </option>

                      </select>

                    </ng-container>

                    <ng-template #multiCustomer>

                      <label class="d-flex justify-content-between align-items-center">
                        <span>Customer *</span>

                        <div class="d-flex gap-2">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            (click)="selectAll(aggiungiUtenteForm, 'customer', listCustomerView)">
                            Select All
                          </button>

                          <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary"
                            (click)="clearAll(aggiungiUtenteForm, 'customer')">
                            Clear
                          </button>
                        </div>
                      </label>

                      <div class="selection-box">
                        <div class="selection-list">
                          <div
                            *ngFor="let customer of listCustomerView"
                            class="selection-row"
                            [class.active]="isSelected(aggiungiUtenteForm, 'customer', customer)"
                            (click)="toggleSelection(aggiungiUtenteForm, 'customer', customer)">

                            <input
                              type="checkbox"
                              class="form-check-input"
                              [checked]="isSelected(aggiungiUtenteForm, 'customer', customer)"
                              tabindex="-1">

                            <span>{{ customer }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="selection-summary">
                        Selected: {{ getSelectedCount(aggiungiUtenteForm, 'customer') }}
                      </div>

                    </ng-template>

                  </div>
                </ng-container>
            </div>
          <div class="row mt-2" *ngIf="isFasAdmin() && billingTableLO && billingTableLO.length > 0">
            <div class="col-md-12">
              <label class="d-flex justify-content-between align-items-center">
                <span>
                  Billing Account(s)
                  <span *ngIf="aggiungiUtenteForm.get('group')?.value !== 'FLEET_MANAGER' && aggiungiUtenteForm.get('group')?.value !== 'FLEET_MANAGER_ADMIN'">
                    Lead Operator
                  </span>
                </span>

                <div class="d-flex gap-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    (click)="selectAll(aggiungiUtenteForm, 'billingAccountLO', getBillingIds(billingTableLO))">
                    Select All
                  </button>

                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="clearAll(aggiungiUtenteForm, 'billingAccountLO')">
                    Clear
                  </button>
                </div>
              </label>

              <div class="selection-box">
                <div class="selection-list">
                  <div
                    *ngFor="let account of billingTableLO"
                    class="selection-row"
                    [class.active]="isSelected(aggiungiUtenteForm, 'billingAccountLO', account.billingAccountId)"
                    (click)="toggleSelection(aggiungiUtenteForm, 'billingAccountLO', account.billingAccountId)">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      [checked]="isSelected(aggiungiUtenteForm, 'billingAccountLO', account.billingAccountId)"
                      tabindex="-1">

                    <span class="billing-account-info">
                      <span class="billing-account-id">{{ account.billingAccountId }}</span>

                      <small class="billing-account-customer" *ngIf="account.customerName">
                        {{ account.customerName }}
                      </small>

                      <small class="billing-account-local-customer" *ngIf="account.localCustomerName">
                        {{ account.localCustomerName }}
                      </small>
                    </span>
                  </div>
                </div>
              </div>

              <div class="selection-summary">
                Selected: {{ getSelectedCount(aggiungiUtenteForm, 'billingAccountLO') }}
              </div>
            </div>
          </div>
          <div class="row mt-2" *ngIf="isFasAdmin() && billingTableData && billingTableData.length > 0">
            <div class="col-md-12">
              <label class="d-flex justify-content-between align-items-center">
                <span>Billing Account(s) B Operator*</span>

                <div class="d-flex gap-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    (click)="selectAll(aggiungiUtenteForm, 'billingAccount', getBillingIds(billingTableData))">
                    Select All
                  </button>

                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="clearAll(aggiungiUtenteForm, 'billingAccount')">
                    Clear
                  </button>
                </div>
              </label>

              <div class="selection-box">
                <div class="selection-list">
                  <div
                    *ngFor="let account of billingTableData"
                    class="selection-row"
                    [class.active]="isSelected(aggiungiUtenteForm, 'billingAccount', account.billingAccountId)"
                    (click)="toggleSelection(aggiungiUtenteForm, 'billingAccount', account.billingAccountId)">

                    <input
                      type="checkbox"
                      class="form-check-input"
                      [checked]="isSelected(aggiungiUtenteForm, 'billingAccount', account.billingAccountId)"
                      tabindex="-1">

                    <span class="billing-account-info">
                      <span class="billing-account-id">{{ account.billingAccountId }}</span>

                      <small class="billing-account-customer" *ngIf="account.customerName">
                        {{ account.customerName }}
                      </small>

                      <small class="billing-account-local-customer" *ngIf="account.localCustomerName">
                        {{ account.localCustomerName }}
                      </small>
                    </span>
                  </div>
                </div>
              </div>

              <div class="selection-summary">
                Selected: {{ getSelectedCount(aggiungiUtenteForm, 'billingAccount') }}
              </div>
            </div>
          </div>
            <div class="row mt-2" *ngIf="addFormDisabled()">
                <span class="span-error">Fill in all mandatory fields marked with *</span>
            </div>
        </div>
        <div class="modal-footer footer-modal-background-color">
            <button class="btn btn-primary btn-lg active" [disabled]="addFormDisabled()" (click)="addUtente()">Add
                User</button>
            <button class="btn btn-primary btn-lg active button-reset" (click)="modal.close(false)">Cancel</button>
        </div>
    </form>
</ng-template>

<ng-template #changePasswordPopup let-modal>
    <div class="modal-header header-background-color">
        <img src="../../../assets/FASWhiteLabelPortal/freemove-logo.svg" width="180" class="d-inline-block align-top" alt="">
        <div (click)="modal.close(false)">
            <i class="fa-solid fa-xmark close-modal-color"></i>
        </div>
    </div>
    <form [formGroup]="changePasswordForm">
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <label>New Password:</label><br>
                    <input type="password" formControlName="newPassword"
                        [ngClass]="{'input-error': changePasswordForm && changePasswordForm.get('newPassword')?.errors && changePasswordForm.get('newPassword')?.hasError('required')}"
                        class="form-control" id="newPassword" name="newPassword" placeholder="New Password">
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <label>Confirm Password:</label><br>
                    <input type="password" formControlName="confirmPassword"
                        [ngClass]="{'input-error': changePasswordForm && changePasswordForm.get('nome')?.errors && changePasswordForm.get('nome')?.hasError('required')}"
                        class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm Password">
                </div>
            </div>

        </div>



        <div class="row mt-2" *ngIf="changePasswordFormDisabled()">
            <span class="span-error">Fill in all mandatory fields marked with *</span>
        </div>
        <div class="modal-footer footer-modal-background-color">
            <button class="btn btn-primary btn-lg active" [disabled]="updateFormDisabled()"
                (click)="confirmChange()">Save</button>
            <button class="btn btn-primary btn-lg active button-reset" (click)="modal.close(false)">Cancel</button>
        </div>
    </form>
</ng-template>
